import axios from '../apiEditor';
import qs from 'qs';

export default {
	getKeyPadById(keypadId) {
		return axios.get().get(`/editor/keypads/getbyid?id=${keypadId}`);
	}
};
